import { api } from './client'

const formDesignerService = {
  getLayouts: (objectType) => api.get('/form-designer/layouts', { objectType }),
  setDefaultLayout: (data) => api.post('/form-designer/layouts/default', data),
  deleteLayout: (id, objectType) => api.delete(`/form-designer/layouts/${id}`, { objectType }),
  checkName: (layoutName) => api.post('/form-designer/check-name', { layoutName }),
}

export default formDesignerService
